import { createContext } from 'react';
import { NavigateOptions } from 'react-router';

import { StepModel } from './interfaces/Step';

export interface StepsProviderStore {
  steps: StepModel[];
}

export interface StepsUpdateProviderStore {
  completeCurrentStep: () => void;
  navigateToActiveStep: () => void;
  navigateToNextStep: (navigationOptions?: NavigateOptions) => void;
  navigateToPrevStep: () => void;
}

export const StepsContext = createContext({} as StepsProviderStore);
export const StepsUpdateContext = createContext({} as StepsUpdateProviderStore);
